export default "__VITE_ASSET__4a48cb95__"